import React from "react";

import { LomavisDoughnutChart1, LomavisDoughnutChart1Props } from "@/lomavisSharedUi/atoms/charts/LomavisDoughnutChart1/LomavisDoughnutChart1";
import { LomavisTableWithSum1, LomavisTableWithSum1Props } from "@/lomavisSharedUi/organisms/tables/LomavisTableWithSum1";
import { LomavisBarChart1, LomavisBarChart1Props } from "@/lomavisSharedUi/atoms/charts/LomavisBarChart1";
import { LomavisLayout1 } from "@/lomavisSharedUi/organisms/layouts/LomavisLayout1/LomavisLayout1";

interface LomavisDistributionGrowthCard1Props {
    title: string;
    subTitle?: string;
    doughnutChartData: LomavisDoughnutChart1Props;
    barChartData: LomavisBarChart1Props;
    tableData: LomavisTableWithSum1Props;
}

/**
* Organisms: LomavisDistributionGrowthCard1
*/
export const LomavisDistributionGrowthCard1: React.FC<LomavisDistributionGrowthCard1Props> = ({ title, doughnutChartData, barChartData, tableData }) => {

    return <LomavisLayout1
        title={title}
        topLeft={<LomavisDoughnutChart1 {...doughnutChartData} />}
        topRight={<LomavisBarChart1 {...barChartData} />}
        bottom={<LomavisTableWithSum1 {...tableData} />}
    />;
};
